/**
 * The Rappi APP WebView injects some auxiliary functions on the window object.
 */
const openPopup = (url, { width = 550, height = 400 }) => {
  const config = {
    height,
    width,
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes',
  };

  window.open(
    url,
    '',
    Object.keys(config)
      .map(key => `${key}=${config[key]}`)
      .join(', '),
  );
};

/**
 * Closes the WebView, redirecting the user to the Rappi APP home.
 */
export const goBackToApp = () => {
  if (window.app?.endCall) window.app.endCall();
  if (window.appInterface?.endCall) window.appInterface.endCall();
  if (window.webkit?.messageHandlers?.endCall?.postMessage) window.webkit.messageHandlers.endCall.postMessage('');
};

/**
 * Opens the given URL on the native browser.
 */
export const openURL = (url, options) => {
  if (window.app?.openURL) window.app.openURL(url);
  else if (window.appInterface?.openURL) window.appInterface.openURL(url);
  else if (window.webkit?.messageHandlers?.openURL?.postMessage)
    window.webkit.messageHandlers.openURL.postMessage(url);
  else {
    if (options?.popup) openPopup(url, options);
    else window.open(url);
  }
};